<template>
    <div class="px-2 slide-banner"  v-if="banners.length > 0">
        <hooper 
            :itemsToShow="isDesktopVersion() && banners.length > 1 ? 2 : 1" 
            :autoPlay="autoplay"  
            :class="{'rounded-[15px]' : ($root.template === 'video_template' || $root.template === 'slider_template')}" 
            :rtl="doRtl()" 
            :playSpeed="3000" 
            :infiniteScroll="true"
            :style="{
                boxShadow: !isDesktopVersion() ? '1px 0px 12px rgba(0, 0, 0, 0.12)' : 'none',
                gap: isDesktopVersion() && banners.length > 1 ? '20px' : '0'
            }"
        >
            <slide v-for="(banner, index) in banners" :key="banner.id" :class="{'px-2' : isDesktopVersion()}">
                <img :class="{'rounded-[15px]' : ($root.template === 'video_template' || $root.template === 'slider_template'), 'rounded' : ($root.template !== 'video_template' && $root.template !== 'slider_template')}" :src="$root.getImage(getLangImage(banner))" @click="relocate(banner.external_link)"/>
            </slide>
            <hooper-pagination slot="hooper-addons" v-if="banners.length > 1"></hooper-pagination>
        </hooper>
    </div>
</template>

<script>
    import { Hooper, Slide, Pagination as HooperPagination } from 'hooper'
    import 'hooper/dist/hooper.css';
    export default {
        name: "TopBanner",
        components: {Hooper, Slide, HooperPagination},

        computed: {
            autoplay: function () {
                return this.banners.length > 1;
            },
            banners() {
                if (this.$root.hotel.banners !== undefined && this.$root.hotel.banners.length > 0) {
                    return this.$root.hotel.banners.filter(item => item.position === 'top');
                }
                return [];
            }
        },

        methods: {
            getLangImage(banner) {
                return (banner.file_langs !== null && banner.file_langs[this.$root.currentLanguage] && banner.file_langs[this.$root.currentLanguage].file) ? banner.file_langs[this.$root.currentLanguage].file : banner.banner;
            },

            relocate(link) {
                this.$root.yandexGoal('goal-click-banner');
                this.$root.yandexGoal('goal-click-banner-top');

                if (link !== null && link.length > 0) {
                    window.location.href = link;
                }
            },

            doRtl() {
                if (this.$root.currentLanguage == 'il' || this.$root.currentLanguage == 'ar') {
                    return true;
                }
            },            
        }
    }
</script>

<style scoped>
    .slide-banner .hooper {
        height: auto !important;
    }
</style>